'use strict';

module.exports = require('./node-request');